module.exports = __webpack_public_path__ + "img/RUN-FOREFOOT-05.35eb2cf0.png";